















































































import { Component, Vue } from "vue-property-decorator";
import { list } from "./gameConfig";
import { newGameList } from "@/req/homes";
@Component({
  components: {},
})
export default class Home extends Vue {
  public widths = 0;
  public limit = 0;
  public lefts = 0;
  public list: any = [];
  public arrList: any = [];
  public leftShow = false;
  public mounted() {
    this.getList();
  }
  public async getList() {
    const res = await newGameList();
    if (res.code == 200) {
      const arr: any = [];
      // res.data = list;
      for (const i of Object.keys(res.data)) {
        // let o = {}
        // o[i] = res.data[i]
        let limitss = 1;
        let classNames = "";
        if (res.data[i].length >= 1 && res.data[i].length <= 4) {
          limitss = 1;
          classNames = "recomNavBox_list";
        }
        if (res.data[i].length >= 5 && res.data[i].length <= 8) {
          limitss = 2;
          classNames = "recomNavBox_list_two";
        }
        if (res.data[i].length >= 9 && res.data[i].length <= 12) {
          limitss = 3;
          classNames = "recomNavBox_list_three";
        }
        if (res.data[i].length >= 13 && res.data[i].length <= 16) {
          limitss = 4;
          classNames = "recomNavBox_list_four";
        }
        arr.push({
          times: i,
          timess: this.dateCompare(i),
          list: res.data[i],
          lengths: res.data[i].length,
          limits: limitss,
          className: classNames,
          lefts: 0,
        });
      }
      this.list = arr;
      this.list.forEach((item, index) => {
        this.widths += item.limits;
        item.lefts += this.widths;
        this.$set(item, "indexs", index);
      });
      if (this.widths - this.list[this.limit].lefts <= 4) {
        this.leftShow = false;
      } else {
        this.leftShow = true;
      }
      setTimeout(() => {
        this.cshMove();
      }, 500);
    }
  }
  public async cshMove() {
    const indexOne = this.list.filter((item, index) => {
      return item.timess == "昨天";
    });
    const indexTwo = this.list.filter((item, index) => {
      return item.timess == "今天";
    });
    const indexThree = this.list.filter((item, index) => {
      return item.timess == "明天";
    });
    if (indexTwo.length == 0) {
      if (indexOne.length == 0) {
        if (indexThree.length == 0) {
          const a = "";
        } else {
          this.limit = indexThree[0].indexs;
        }
      } else {
        this.limit = indexOne[0].indexs;
      }
    } else {
      this.limit = indexTwo[0].indexs;
    }
    this.goMove();
  }
  public async goMove() {
    const recomNavBoxs: any = this.$refs.recomNavBoxs;
    const recomBoxLists: any = this.$refs.recomBoxLists;
    recomNavBoxs.style.marginLeft =
      "-" +
      (this.list[this.limit].lefts * 284.8 -
        this.list[this.limit].limits * 284.8) +
      "px";
    recomBoxLists.style.marginLeft =
      "-" +
      (this.list[this.limit].lefts * 284.8 -
        this.list[this.limit].limits * 284.8) +
      "px";
  }
  public addMove(shows) {
    const recomNavBoxs: any = this.$refs.recomNavBoxs;
    const recomBoxLists: any = this.$refs.recomBoxLists;
    if (shows) {
      if (this.widths - this.list[this.limit].lefts <= 4) {
        this.leftShow = false;
      } else {
        this.leftShow = true;
      }
      this.limit++;
      recomNavBoxs.style.marginLeft =
        "-" + this.list[this.limit - 1].lefts * 284.8 + "px";
      recomBoxLists.style.marginLeft =
        "-" + this.list[this.limit - 1].lefts * 284.8 + "px";
    } else {
      this.limit--;
      this.leftShow = true;
      if (this.limit == 0) {
        recomNavBoxs.style.marginLeft = "0px";
        recomBoxLists.style.marginLeft = "0px";
      } else {
        recomNavBoxs.style.marginLeft =
          "-" + this.list[this.limit - 1].lefts * 284.8 + "px";
        recomBoxLists.style.marginLeft =
          "-" + this.list[this.limit - 1].lefts * 284.8 + "px";
      }
    }
  }
  public dateCompare(date) {
    if (date == this.dealTime(6)) {
      return "今天";
    } else if (date == this.dealTime(9)) {
      return "明天";
    } else if (date == this.dealTime(3)) {
      return "昨天";
    } else {
      return date.slice(5);
    }
  }
  public dealTime(v) {
    const b = 24 * 60 * 60 * 1000;
    const day = new Date();
    v == 3
      ? day.setTime(day.getTime() - b)
      : v == 6
      ? day.setTime(day.getTime())
      : day.setTime(day.getTime() + b);
    const dayMon =
      day.getMonth() + 1 >= 10
        ? day.getMonth() + 1
        : "0" + (day.getMonth() + 1);
    const dayDat = day.getDate() >= 10 ? day.getDate() : "0" + day.getDate();
    const s = day.getFullYear() + "-" + dayMon + "-" + dayDat;
    return s;
  }
  public returnTime(item) {
    if (
      item.timess == "昨天" ||
      item.timess == "今天" ||
      item.timess == "明天"
    ) {
      return `(${item.times.slice(5)})`;
    } else {
      return "";
    }
  }
  public toGame(gameId) {
    this.$router.push({
      path: "/gameDetail",
      query: { id: gameId },
    });
  }
}
